import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

interface Payload {
  username: string;
}

const useSendForgotPasswordCodeQuery = () => {
  const { mutateAsync, isLoading, isError } = useMutation(({ username }: Payload) =>
    api.post(API_URL.FORGOT_PASSWORD, {
      username,
    })
  );

  return {
    sendForgotPasswordCode: mutateAsync,
    isLoading,
    isError,
  };
};

export default useSendForgotPasswordCodeQuery;
